import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["selector", "content"]

    get checked() {
        return this.selectorTarget.checked
    }

    connect() {
        this.changeSelector()
    }

    changeSelector() {
        this.contentTarget.style.display = this.checked ? "block" : "none"
    }
}
